import { render, staticRenderFns } from "./TestTypeChecklistBox.vue?vue&type=template&id=3d567cf7&scoped=true&"
import script from "./TestTypeChecklistBox.vue?vue&type=script&lang=js&"
export * from "./TestTypeChecklistBox.vue?vue&type=script&lang=js&"
import style0 from "./TestTypeChecklistBox.vue?vue&type=style&index=0&id=3d567cf7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d567cf7",
  null
  
)

export default component.exports